import { is58App, isIos } from "../UA";

/**
 * 获取?name=xxx&age=xxx指定key的值
 */
export function getSearchString(search: string, name: string): string {
    const reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i');
    const r = search.substr(1).match(reg);
    if (r !== null) return unescape(r[2]);
    return '';
}

/**
 * 解析URL传参
 * @param {Object} key
 */
export function getQueryString(key)
{
    var after = window.location.href;
    if(after.indexOf('?') === -1) return ''; //如果url中没有传参直接返回空
    //直接通过hash来取
    after = window.location.search && window.location.search.length > 1 ? window.location.search.substring(1) : window.location.hash.split("?")[1];

    if(after) {
        var reg = new RegExp('(^|&)' + key + '=([^&]*)(&|$)');
        var r = after.match(reg);
        if(r !== null) return  decodeURIComponent(r[2]);
    }

    return '';
}
/**
 * 以正则的方式解析参数key
 * @param key 
 * @returns 
 */
export function getParamkey(key) {
    var reg = new RegExp('(^|[&,?])' + key + '=([^&,^#]*)(&|#|$)');
    const r = window.location.href.match(reg);
    if (r) {
        return r[2];
    }
    return '';
}


const hostName = window.location.hostname;
export const onLinehost = hostName === 'jrhaojie.58.com' || hostName === 'haojie.58.com' || hostName === 'dk.58.com' || hostName === 'testhaojie.58.com' || hostName === 'test-haojie.58.com';
export const EMS_ENVIRONMENT = onLinehost ?  '//emsapi.58.com' : '//emsapi.58v5.cn';

/**
 * 获取纯数字 有的输入框只允许输入数字且有长度限制 所以需要过滤数字功能
 */
export function getPureNumbers(str: string | number, maxLength: number): string {
    if (!str) return '';
    return String(str).replace(/[^0-9]/g, '').substr(0, maxLength);
}

/**
 * 输入框内容为用空格隔开数字的方式时，内容增多时判断光标的位置
 */
export function calcPos(prePos: number, preCtrlVal: string, rawVal: string, ctrlVal: string, placeholderChars, maskReg) {
    const editLength = rawVal.length - preCtrlVal.length;
    const isAddition = editLength > 0;
    let pos = prePos;
    if (isAddition) {
        const additionStr = rawVal.substr(pos - editLength, editLength);
        let ctrlCharCount = additionStr.replace(maskReg, '').length;
        pos -= (editLength - ctrlCharCount);
        let placeholderCharCount = 0;
        while (ctrlCharCount > 0) {
            if (placeholderChars.indexOf(ctrlVal.charAt(pos - ctrlCharCount + placeholderCharCount)) === -1) {
                ctrlCharCount -= 1;
            } else {
                placeholderCharCount += 1;
            }
        }
        pos += placeholderCharCount;
    }
    return pos;
}

// 判断58同城APP是否有隐藏提示功能，版本必须大于10.21
function is58AppHasPrivacyAccess() {
    if (!window.XJJSBridge.headers.isReady || !is58App()) return false;
    const { appVersion } = window.XJJSBridge.common;
    return window.XJJSBridge.util.compareVersion(appVersion, '10.23') >= 0;
}


/**
 * 58app 私密弹框通过流程
 * @returns promis
 */
export function appBy58PrivacyAccess() {
    return new Promise((resolve, reject) => {
        if (isIos() && is58AppHasPrivacyAccess()) {
            // 判断是否已经授权
            window.XJJSBridge.invoke(
                'get_privacy_access',
                { message: '' },
                (code) => {
                    // code 1 已授权，0未授权
                    console.log('get_privacy_access code', code);
                    if (code === '1') {
                        resolve({ code: '1' })
                    } else {
                        window.XJJSBridge.invoke(
                            'show_privacy_access',
                            { message: '' },
                            (code) => {
                                // code 1 已授权，0未授权
                                if (code === '1') {
                                    resolve({ code: '1' })
                                } else {
                                    reject({ code: '0', msg: '请同意《隐私协议授权申请》后重试' })
                                    // Toast.fail('请同意《隐私协议授权申请》后重试');
                                }
                            }
                        );
                    }
                }
            );
        } else {
            resolve({ code: '1' })
        }
    })
}